import React, { useEffect, useMemo, useState } from 'react'
import Button from 'react-bootstrap/Button'
import {Container, Form} from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Modal from 'react-bootstrap/Modal'
import {useTranslation} from 'react-i18next'
import YesNo from '../../enums/YesNo'
import DateUtil from '../../utils/DateUtil'
import {loadBestBuyBasketByPortfolioId} from '../../services/api'

export default function BasketDetailReport(props) {
  const {t} = useTranslation()
  const {basket, onHide} = props
  const initialStates = useMemo(
    () => ({
      portfolio: null,
      loading: true,
    }),
    [],
  )
  const [state, setState] = useState(initialStates)
  const { portfolio, loading } = state;

  const fetchData = (givenPortfolioId) => {
    loadBestBuyBasketByPortfolioId({
      id: givenPortfolioId,
      sort_field: '-id',
    }).then(response => {
      setState(prev => ({
        portfolio: response.data,
        loading: false,
      })
      )}
    )
  }

  const onClose = () => {
    setState(prev => ({
      portfolio: null,
      loading: true,
    })
    )
    onHide()
  }

  useEffect(() => {
    console.log("props: ", props)
    console.log("basket: ", basket) 
    // console.log("portfolioId: ", portfolioId) 
    console.log("onHide: ", onHide)
    fetchData(basket);

  }
  )

  return (
    <Modal
      size="lg"
      centered
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {t('bestBuy.detail.title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Card>
          <Card.Body>
            {loading === false ? (
            <Card.Text>
              <Col xs={4} md={4}>
                <div>
                  <h6>{t('common.id')}</h6>
                  <p className="category">{portfolio.id}</p>
                </div>
              </Col>

              <Col xs={4} md={4}>
                <div>
                  <h6>{t('bestBuy.basket-price-usdt')}</h6>
                  <p className="category">{portfolio.basket_price.usdt}</p>
                </div>
              </Col>

              <Col xs={4} md={4}>
                <div>
                  <h6>{t('common.user')}</h6>
                  <p className="category">{portfolio.customer_data.name}</p>
                </div>
              </Col>

              <Col xs={4} md={4}>
                <div>
                  <h6>{t('customerProfiles.national-code')}</h6>
                  <p className="category">{portfolio.customer_data.melli_code}</p>
                </div>
              </Col>

              <Col xs={4} md={4}>
                <div>
                  <h6>{t('customerProfiles.phone_num')}</h6>
                  <p className="category">{portfolio.customer_data.mobile}</p>
                </div>
              </Col>

              <Col xs={4} md={4}>
                <div>
                  <h6>{t('common.create_datetime')}</h6>
                  <p className="category">
                    {DateUtil.convertToJalaliBirthDate(portfolio.created_on)}
                  </p>
                </div>
              </Col>

              <Col xs={4} md={4}>
                <div>
                  <h6>{t('bestBuy.last_update')}</h6>
                  <p className="category">
                    {DateUtil.convertToJalaliBirthDate(portfolio.last_update)}
                  </p>
                </div>
              </Col>

              <Col xs={4} md={4}>
                <div>
                  <h6>{t('bestBuy.detail.entered_tether')}</h6>
                  <p className="category">{portfolio.entered_usdt}</p>
                </div>
              </Col>

              <Col xs={12} md={12}>
                <div>
                  <h6>{t('bestBuy.detail.detail')} </h6>
                  <p className="category">{JSON.stringify(portfolio.detail)}</p>
                </div>
              </Col>
            </Card.Text>
          ) : <p>loading...</p>}
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>{t('common.close')}</Button>
      </Modal.Footer>
    </Modal>
  )
}
